var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-empty-state',{attrs:{"title":_vm.s__('SecurityReports|Sorry, your filter produced no results'),"svg-path":_vm.noVulnerabilitiesSvgPath,"svg-height":150,"description":_vm.s__(`SecurityReports|To widen your search, change or remove filters above`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }